module.exports = __webpack_public_path__ + "img/35a0b0c.svg";